import React from "react";
import { Table } from "antd";
import TablePageSize from "./TablePageSize";

const LandingTable = ({
  data,
  onChange,
  loading,
  changePageSize,
  setSelectedRows,
  routes
}) => {
  const columns = [
    {
      title: "ФИО",
      key: "fio",
      sorter: true,
      render: row => {
        return (
          <div className={"table-cell"}>
            <span className={"table-cell__row"}>{row.second_name || "–"}</span>
            <span className={"table-cell__row"}>
              {row.first_name ? row.first_name + " " + row.middle_name : "–"}
            </span>
          </div>
        );
      }
    }
  ];
  routes &&
    routes.forEach((route, index) => {
      if (route.route_point_type_id !== 1 && route.route_point_type_id !== 3) {
        columns.push({
          title: `Пром. пункт ${index}`,
          render: row => {
            const thisRoute = row.routes.find(
              item => item.route_id === route.route_id
            );

            return (
              <div className={"table-cell"}>
                <span className={"table-cell__row"}>
                  {thisRoute && thisRoute.pivot && thisRoute.pivot.boarding
                    ? thisRoute.pivot.disembarking
                      ? "Высадка, Посадка"
                      : "Посадка"
                    : thisRoute &&
                      thisRoute.pivot &&
                      thisRoute.pivot.disembarking
                    ? "Высадка"
                    : "–"}
                </span>
                <span className={"table-cell__row"}>{route.route}</span>
              </div>
            );
          }
        });
      }
    });

  return (
    <>
      <Table
        columns={columns}
        dataSource={data.data}
        className={"landing-table"}
        rowKey={"person_id"}
        onChange={onChange}
        locale={{
          emptyText: "Нет пассажиров"
        }}
        rowSelection={{
          type: "checkbox",
          onSelect: (record, selected, selectedRows) => {
            setSelectedRows(selectedRows);
          },
          onSelectAll: (record, selected, selectedRows) => {
            setSelectedRows(selectedRows);
          }
        }}
        loading={loading}
        pagination={{
          pageSize: data ? data.per_page : 0,
          total: data ? data.total : 0,
          current: data ? data.current_page : 0
        }}
      />
      {data && data.data && data.data.length > 0 && (
        <TablePageSize
          changePageSize={changePageSize}
          pages={data ? data.per_page : 0}
        />
      )}
    </>
  );
};

export default LandingTable;
